var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeCol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "112px",
    height: "37px",
    viewBox: "0 0 112 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Third Screen Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 1,
    y: 1,
    width: 110,
    height: 35,
    rx: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 110,
    height: 35,
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Third-Screen-Icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    id: "Border",
    stroke: "#FFFFFF",
    mask: "url(#mask-2)",
    strokeWidth: 2,
    strokeDasharray: 5,
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "iNNER-3",
    fill: "#FFFFFF",
    x: 76,
    y: 5,
    width: 30.6,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Inner-2",
    fill: "#FFFFFF",
    x: 41,
    y: 5,
    width: 30.6,
    height: 27,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Inner-1",
    fill: "#FFFFFF",
    x: 6,
    y: 5,
    width: 30.6,
    height: 27,
    rx: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeCol);
export default __webpack_public_path__ + "static/media/three-col.35fecd03e9b7f9fcbb72f57c041a530e.svg";
export { ForwardRef as ReactComponent };